const page_500 = {
	description: "Sorry, er ging iets mis aan onze kant. Probeer het later nog eens.",
	home_button: "Ga naar de homepagina",
	return_button: "Probeer het nog eens",
	title: "500 Error",
};

export default page_500;
